module.exports = __webpack_public_path__ + "media/entities/1302-9b9c7895.png";